import React, { memo, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useModal } from '@context/ModalsContext'

import { Button } from '@ui/components/Button'
import { CloseIcon } from '@ui/icons/Close.icon'

import { useWindowResize } from '@utils/domUtils'

import type { CurrencyType } from '@model/WalletDto'

import { CloseAllTradesModal } from '../Modals/CloseAllTradesModal'
import { useFixTradingWebSocketContext } from '../context/FixTradingWebSocketContext'
import type { PortfolioTrade } from '../hooks/useDxtradePortfolioTrades'

import styles from '../Portfolio.page.module.scss'

type Props = {
  isOpenTab: boolean
  activePath: string
  trades: PortfolioTrade[]
  accountCurrency?: CurrencyType
  accountCode?: string
  onCancelAll: () => void
}

const BulkActionsRowComponent: React.FC<Props> = (props) => {
  const { isOpenTab, trades, accountCurrency, accountCode } = props

  const { t } = useTranslation()
  const isMobile = useWindowResize()

  const { closeAllPositions } = useFixTradingWebSocketContext()

  const closeAllTradesModal = useModal(CloseAllTradesModal, { closeAllPositions })

  const handleCloseAll = useCallback(() => {
    if (!trades.length || !accountCode) return
    closeAllTradesModal.open({ trades, accountCurrency, accountCode })
  }, [trades, accountCurrency, accountCode, closeAllTradesModal])

  return (
    <>
      {isOpenTab && !!trades.length && (
        <div className={styles.bulkActions}>
          <Button
            size={isMobile ? 'sm' : 'md'}
            variant='danger'
            onClick={handleCloseAll}
            iconLeft={CloseIcon}
            disabled={!accountCode}
          >
            {t('Portfolio.Close all')}
          </Button>
        </div>
      )}
      {/* it was deceided to remove bulk action for pending orders for now
      {/* {activePath === 'pending' && (
        <div className={styles.bulkActions}>
          <Button.Secondary size='md' onClick={onCancelAll} iconLeft={CloseIcon}>
            {t('Cancel all')}
          </Button.Secondary>
        </div>
      )} */}
    </>
  )
}

export const BulkActionsRow = memo(BulkActionsRowComponent)
